import RootLayout from '@/components/RootLayout';
import { getseo } from '@/libs/fncs';
import { baseUrl, chaind, isApp, mountedd, paged, seod, sideaccord, tableLoad, adtyped, adviewd, popStatusd, apiUrl, stickyd, networkList, displayadd, dataloadd } from '@/libs/store';
import { useHookstate } from '@hookstate/core';
import {
  Box,
} from '@mui/material';
import Head from 'next/head';
import { withRouter } from 'next/router';
import { useEffect } from 'react';
import Script from 'next/script';
import axios from 'axios';
/* 
export const config = {
  runtime: 'experimental-edge',
};
 */
export async function getStaticProps({ params: { chain } }) {
  chain = chain.toLowerCase();
  var seoData = getseo(chain);
  seoData["canUrl"] = baseUrl + "/" + chain;
  try {
    /*if (chain == 'all') {

    } else */if (networkList[chain]) {
      try {
        //await axios.get(`${apiUrl}/netfind?chain=${chain}`).then(async (res) => {
        await fetch(`${apiUrl}/netfind?chain=${chain}`).then(async (res) => {
          res = { data: await res.json() };
          if (res.data.data && res.data.data[0]) {
            seoData.chain = res.data.data[0];
          } else {
            seoData.chain = '';
          }
        });
      } catch (e) {
        //console.log(e);
      }
    } else {
      return {
        notFound: true,
      }
    }
  } catch (e) {
    return {
      notFound: true,
    }
  }
  try {
    if (networkList[chain]) {
      //await axios.get(`${apiUrl}/tokenlist?chain=${chain}&offset=0`).then(async (res) => {
      await fetch(`${apiUrl}/tokenlist?chain=${chain}&offset=0`).then(async (res) => {
        res = { data: await res.json() };
        var temp = res.data.data[0] && res.data.data[0].result ? res.data.data[0].result : [];
        var side = res.data.data[0] && res.data.data[0].side ? res.data.data[0].side : { chain: [{ symbol: 'all', blockNumber: 0, coinUSD: 0 }], gainers: [], losers: [], newpair: [] };
        await Promise.allSettled(temp.map(async (row, i) => {
          temp[i].id = i + 1;
        }))
        seoData.apidata = temp;
        seoData.apisidedata = side;
        //console.log("temp, side", temp, side);
      });
    }
  } catch (e) {
    //console.log(e);
  }
  if (seoData.chain == '') {
    return {
      notFound: true,
    }
  } else {
    return {
      props: seoData,
      //revalidate: 120,
    }
  }
}

export async function getStaticPaths() {
  const paths = [];
  Object.keys(networkList).map((chain) => { paths.push({ params: { chain } }); });
  //console.log(paths);
  return {
    paths,
    fallback: false, //'blocking',
  };
}


export default withRouter(function ChainRoot({ titleData, chain, descriptionData, router, canUrl, apidata, apisidedata }) {

  //const router = useRouter();
  const chainName = useHookstate(chaind);
  const pageName = useHookstate(paged);
  const seo = useHookstate(seod);
  const mounted = useHookstate(mountedd);
  const dataload = useHookstate(dataloadd);
  const tableLoading = useHookstate(tableLoad);
  const selAcc = useHookstate(sideaccord);
  const popStatus = useHookstate(popStatusd);
  const adviewable = useHookstate(adviewd);
  const adtype = useHookstate(adtyped);
  const sticky = useHookstate(stickyd);
  const displayad = useHookstate(displayadd);

  useEffect(() => {
    router.beforePopState(({ as }) => {
      const hrefsplit = as.split('/');
      selAcc.set(2);
      tableLoading.set(true);
      chainName.set(hrefsplit[1] ? hrefsplit[1] : 'all');
      pageName.set('home');
      //console.log("came to back/forward", as, router.asPath, hrefsplit);
      return;
    });
    if (mounted.get() || isApp) {
      return;
    } else {
      if (chain == 'all') {
        chainName.set("all");
        pageName.set('home');
        router.push(`/[chain]`, `/all`, { shallow: true });
        mounted.set(true);
        setTimeout(() => {
          dataload.set(true);
        }, 20000);
      } else {
        chainName.set(chain);
        seo[pageName.get()].merge({ tabTitle: titleData, description: descriptionData });
        mounted.set(true);
        setTimeout(() => {
          dataload.set(true);
        }, 20000);
      }
      setTimeout(() => {
        checkAdBlocker();
      }, 20000);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [router]);

  const checkAdBlocker = async () => {
    fetch("https://cdn.bmcdn6.com/js/64c8e7a64485b30b6fb7fecc.js?v=1692026187741", { //"https://cdn.bmcdn4.com/js/62f4e0ae6703276b08cd86e4.js?v=1690148231602"https://ad.a-ads.com/2189429?size=320x50
      method: "HEAD",
      mode: "no-cors",
      cache: "no-store",
    }).then((response) => {

      if (!adviewable.get() && displayad.get()) adviewable.set(true);
      if (localStorage.getItem("disclaimer")) {
        popStatus.set(false);
      } else {

      }

    }).catch((e) => {
      adviewable.set(false);
      popStatus.set(true);
    });
  }

  return (
    <Box sx={{ height: "100%", width: "100%", overflow: "auto" }}>
      {
        isApp ? <></> :
          <Head>
            <title>{mounted.get() ? seo.get()[pageName.get()].tabTitle : titleData}</title>
            <meta property="og:title" content={mounted.get() ? seo.get()[pageName.get()].tabTitle : titleData} />
            <meta name="description" content={mounted.get() ? seo.get()[pageName.get()].description : descriptionData} />
            <link rel="canonical" href={mounted.get() ? baseUrl + "/" + chainName.get() : canUrl} />
            <meta property="og:url" content={mounted.get() ? baseUrl + "/" + chainName.get() : canUrl} />
            <meta property="og:description" content={mounted.get() ? seo.get()[pageName.get()].description : descriptionData} />
            <meta name="twitter:title" content={mounted.get() ? seo.get()[pageName.get()].tabTitle : titleData} />
            <meta name="twitter:description" content={mounted.get() ? seo.get()[pageName.get()].description : descriptionData} />
          </Head>
      }
      <Script id="bitad" strategy="lazyOnload" >
        {process.env.NODE_ENV !== 'development' && !isApp && displayad.get() ? `
            setTimeout(() => {
                      !function(e,n,c,t,o,r,d){!function e(n,c,t,o,r,m,d,s,a){s=c.getElementsByTagName(t)[0],(a=c.createElement(t)).async=!0,a.src="https://"+r[m]+"/js/"+o+".js?v="+d,a.onerror=function(){a.remove(),(m+=1)>=r.length||e(n,c,t,o,r,m)},s.parentNode.insertBefore(a,s)}(window,document,"script","62f4e0ae6703276b08cd86e4",["cdn.bmcdn4.com"], 0, new Date().getTime())}();
                      !function(e,n,c,t,o,r,d){!function e(n,c,t,o,r,m,d,s,a){s=c.getElementsByTagName(t)[0],(a=c.createElement(t)).async=!0,a.src="https://"+r[m]+"/js/"+o+".js?v="+d,a.onerror=function(){a.remove(),(m+=1)>=r.length||e(n,c,t,o,r,m)},s.parentNode.insertBefore(a,s)}(window,document,"script","62f4dba0e09b862c31169b6a",["cdn.bmcdn4.com"], 0, new Date().getTime())}();
                      !function(e,n,c,t,o,r,d){!function e(n,c,t,o,r,m,d,s,a){s=c.getElementsByTagName(t)[0],(a=c.createElement(t)).async=!0,a.src="https://"+r[m]+"/js/"+o+".js?v="+d,a.onerror=function(){a.remove(),(m+=1)>=r.length||e(n,c,t,o,r,m)},s.parentNode.insertBefore(a,s)}(window,document,"script","62f4dbd592db9581236c78c5",["cdn.bmcdn6.com"], 0, new Date().getTime())}();
            }, 25000);
                `: ``}
      </Script>
      <RootLayout router={router} pagetype={"home"} chain={chain} apidata={apidata} apisidedata={apisidedata} />
    </Box>
  )
})
